import { memo } from "react";

import { Blueprint } from "types/generated";
import { SortStateDescriptor } from "components/Filters/types";
import TableSimple from "ds/components/TableSimple";

import useBlueprintsTableStore from "./useBlueprintsTableStore";
import useBlueprintsAnalytics from "../hooks/useBlueprintsAnalytics";
import { ANALYTICS, FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { BLUEPRINTS_TABLE_CELLS } from "./Cells";
import { BLUEPRINTS_SORT_CONFIG } from "./constants";

type BlueprintsTableProps = {
  blueprints: Blueprint[];
  loading?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const BlueprintsTable = ({
  blueprints,
  loading,
  rowsPerPage,
  sortCallback,
}: BlueprintsTableProps) => {
  const trackAnalytics = useBlueprintsAnalytics();

  return (
    <TableSimple
      data={blueprints}
      loading={loading}
      store={useBlueprintsTableStore}
      ariaLabel="Blueprints table"
      rowsPerPage={rowsPerPage}
      sortCallback={sortCallback}
      analyticsPage={ANALYTICS.analyticsPage}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      trackAnalytics={trackAnalytics}
      cellPerColumn={BLUEPRINTS_TABLE_CELLS}
      sortConfig={BLUEPRINTS_SORT_CONFIG}
      hasPagination
    />
  );
};

export default memo(BlueprintsTable);
